import { conversationsResource, messagesResource } from './resources';

// packages/ai-mate/csm-conversation-review/src/ui/index.tsx
const conversationRouteNameAndPathFields = {
  name: 'conversationReview',
  path: '/:conversationId?'
};
export const resources = {
  conversationReview: [conversationsResource, messagesResource]
};